<app-loading *ngIf="contentReady"></app-loading>
<div class="container mb-4">
  <div class="row d-flex justify-content-center align-items-center" style="margin-bottom: 70px;">
    <div class="col-12" style="text-align: center;">
      <img style="width: 200px;margin: 0 auto;" src="/assets/e-commerce/icons/48.webp" alt="" />
    </div>
    <div class="col-lg-5 col-md-8 col-sm-12" *ngIf='loggedIn'>
      <h1 class="logintext">{{ "logged in" | transloco }}</h1>
    </div>
    <div class="col-lg-5 col-md-8 col-sm-12" *ngIf='!loggedIn'>
      <h1 class="logintext">{{ "Log in" | transloco }}</h1>
      <form class="form" [formGroup]="person" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label class="label" for="username">{{ "phone" | transloco }}</label>
          <input class="input" type="text" id="username" formControlName="username"
            placeholder="{{ 'username' | transloco }}" />
        </div>
        <div class="form-group">
          <label class="label" for="Password">{{
            "Password" | transloco
            }}</label>
          <input class="input" id="Password" type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="password" placeholder="{{ 'Password' | transloco }}" />
          <button type="button" class="hidePasswordBtn" (click)="togglePasswordVisibility()">
            @if(!isPasswordVisible){
            {{ "Show Password" | transloco }}
            } @else {
            {{ "Hide Password" | transloco }}
            }
          </button>
        </div>

        <h6 class="passtext"> {{ "welcomeinblue" | transloco }}</h6>

        <hr class="line" width="100%" size="3" noshade />
        <button type="submit" class="submit-btn login">
          {{ "Log in" | transloco }}
        </button>
        <div class="rigisterLinkContainer">
          <span>{{ "askforacc" | transloco }} </span>
          <a class="text-decoration-none" routerLink="/Resigter">
            {{"Create Account" | transloco }}
          </a>
        </div>
      </form>
    </div>
  </div>
</div>